module.exports = __webpack_public_path__ + "img/ideal.0a0dad5b.svg";